import * as React from 'react';
import Tooltip from 'antd/lib/tooltip';
import { runwayColors } from '../styles/globalStyles';

interface TimelineAttentionBadgeProps {
    attentionCount: number;
}

export const TimelineAttentionBadge: React.FC<TimelineAttentionBadgeProps> = ({ attentionCount }) => {
    if (attentionCount < 1) {
        return null;
    }

    const title =
        attentionCount === 1 ?
            'An automation on the timeline needs attention'
        :   `${attentionCount} automations on the timeline need attention`;

    return (
        <Tooltip title={title} placement="right">
            <span
                data-testid="timeline-attention-badge"
                style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: runwayColors.statusRed,
                    marginRight: 8,
                    flexShrink: 0,
                }}
            />
        </Tooltip>
    );
};
